<template lang="pug">
.laudo-listagem.w-100
    .tabela(v-if='tableData.length > 0')
        el-table.w-100.my-3.rolagem-tabela-laudo(
            :data='tableData',
            @sort-change='sortChangeRequest'
        )
            el-table-column(
                prop='codigo',
                :label='$t("mensagens.laudos.gridColunaHash")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                prop='informacaoLaudo.nomeArquivoXlsx',
                :label='$t("mensagens.laudos.mutPastagem.arquivo")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    div(
                        v-if='scope.row.informacaoLaudo && scope.row.informacaoLaudo.nomeArquivoXlsx != null'
                    )
                        span {{ getNomeArquivoOriginal(scope.row.informacaoLaudo.nomeArquivoXlsx) }}
                    div(v-else)
                        span --
            el-table-column(
                prop='informacaoLaudo.anoFimAnalise',
                :label='$t("mensagens.laudos.mutPastagem.anoFimAnalise")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                prop='dataCadastroFormatado',
                :label='$t("mensagens.laudos.dataSolicitacao")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                prop='dataFinalizacaoFormatado',
                :label='$t("mensagens.laudos.dataEntrega")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                prop='situacao',
                :label='$t("mensagens.laudos.situacao")',
                sortable='custom'
            )
                template(slot-scope='scope')
                    div(
                        :class='["situacao", classeSituacao.get(scope.row.situacao.codigo)]'
                    ) {{ traduzirSituacao(scope.row.situacao.nome) }}

            el-table-column(
                v-if='showAnalystColumns',
                prop='usuarioAnaliseNome',
                :label='$t("mensagens.laudos.analistaResponsavel")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                v-if='showAnalystColumns',
                prop='usuarioSolicitacaoNome',
                :label='$t("mensagens.comuns.solicitante")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                v-if='showAnalystColumns',
                prop='nomeEmpresa',
                :label='$t("mensagens.laudos.empresa")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                :label='$t("mensagens.comuns.acoes")',
                align='left'
            )
                template(slot-scope='scope')
                    el-dropdown.action-button(trigger='click', :disabled='showAnalystColumns && scope.row.situacao.codigo === "CANCELADO"')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                v-if='!showAnalystColumns',
                                icon='el-icon-view',
                                @click.native='showModalVisualizacao(scope.row)'
                            ) {{ $t('mensagens.laudos.visualizarLaudo') }}
                            el-dropdown-item(
                                v-if='!showAnalystColumns && scope?.row?.situacao?.codigo === "NA_FILA"',
                                icon='el-icon-circle-close',
                                @click.native='showModalCancelarLaudo(scope.row)'
                            ) {{ $t('mensagens.laudos.cancelarLaudo') }}
                            el-dropdown-item(
                                v-if='!showAnalystColumns && scope.row.situacao.codigo === "PROCESSADO"',
                                icon='el-icon-download',
                                @click.native='downloadLaudo(scope.row)'
                            ) {{ $t('mensagens.laudos.baixarLaudo') }}
                            el-dropdown-item(
                                v-if='showAnalystColumns && scope?.row?.situacao?.codigo !== "CANCELADO"',
                                icon='el-icon-upload',
                                @click.native='abreModalInserirResultado(scope.row)'
                            ) {{ $t('mensagens.laudos.enviarResultado') }}
                            el-dropdown-item(
                                v-if='showAnalystColumns && scope?.row?.situacao?.codigo !== "CANCELADO"',
                                icon='el-icon-download',
                                @click.native='baixarArquivo(scope.row)'
                            ) {{ $t('mensagens.laudos.baixarDados') }}
                            el-dropdown-item(
                                v-if='showAnalystColumns && scope?.row?.situacao?.codigo === "CANCELADO"',
                                icon='el-icon-minus'
                            ) {{ $t('mensagens.laudos.nenhumaAcao') }}

    EmptyResultLaudo(
        v-else,
        :semLaudoSelecionado='false',
        :p1='$t("mensagens.comuns.semDados")',
        :p2='$t("mensagens.laudos.naoConseguimosLocalizarNenhumLaudo")'
    )
</template>

<script>
import LaudosService from '@/services/LaudosService';
import { classe } from '@/utils/laudoSituacao';
import EmptyResultLaudo from '@/components/laudos/EmptyResultLaudo.vue';

export default {
    name: 'LaudoListagem',
    components: {
        EmptyResultLaudo
    },
    props: {
        tableData: {
            type: Array,
            required: true
        },
        showAnalystColumns: {
            type: Boolean,
            default: false
        },
        showCarColumn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            classeSituacao: classe,
            VUE_APP_HTTP_PATH: process.env.VUE_APP_HTTP_PATH
        };
    },
    methods: {
        traduzirSituacao(situacao) {
            const normalizedSituacao = situacao
                .toUpperCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/ /g, '-');

            return this.$t(
                `mensagens.relatorioCompartilhamentoDeDados.${normalizedSituacao}`
            );
        },
        showModalVisualizacao(row) {
            this.$emit('handleModalLaudo', row.id);
        },
        showModalCancelarLaudo(row) {
            this.$store.dispatch('processarEventoGoogleAnalytics', {
                eventLabel: 'VISUALIZAR_MODAL_CANCELAMENTO_LAUDOS',
                pageTitle: 'VISUALIZAR_MODAL_CANCELAMENTO_LAUDOS',
                routeName: this.$route?.name,
                routePath: this.$route?.path
            });
            this.$emit('handleModalCancelamento', row.id);
        },
        abreModalInserirResultado(row) {
            this.$emit('handleModalInsercaoResultados', row);
        },
        sortChangeRequest(column) {
            let prop = column.prop;
            if (prop.includes('.')) {
                prop = prop.split('.')[1];
            }

            if (prop === 'dataCadastroFormatado') {
                prop = 'dataCadastro';
            }
            if (prop === 'dataFinalizacaoFormatado') {
                prop = 'dataFinalizacao';
            }

            const params = {
                order: column.order === 'ascending' ? 'ASC' : 'DESC',
                column: prop
            };

            this.$emit('handleSort', params);
        },
        async baixarArquivo(row) {
            try {
                const response = await LaudosService.downloadArquivoLaudoAnalise(row.id);
                if (response.status === 200) {
                    const blob = new Blob([response.data], { type: 'application/xlsx' });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;

                    const contentDisposition = response.headers['content-disposition'];
                    let fileName = 'arquivo.xlsx';
                    if (contentDisposition) {
                        const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                        if (fileNameMatch.length === 2) {
                            fileName = fileNameMatch[1];
                        }
                    }

                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);

                    await this.vincularAnalista(row);

                    this.$notify.success(this.$t('mensagens.laudos.arquivoBaixadoComSucesso'));
                } else {
                    this.$notify.error(this.$t('mensagens.laudos.erroAoBaixarArquivo'));
                }
            } catch (error) {
                this.$notify.error(this.$t('mensagens.laudos.erroAoBaixarArquivo'));
            }
        },
        async vincularAnalista(row) {
            try {
                await LaudosService.vincularAnalista(row.id);
                await this.atualizaStatus(row);
                this.atualizarTabela();
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.laudos.naoFoiPossivelVincularAnalistaAoLaudo'
                    )
                });
            }
        },
        getNomeArquivoOriginal(nomeArquivoXlsx) {
            let i = nomeArquivoXlsx.indexOf('_');

            if (i !== -1 && i < nomeArquivoXlsx.length - 1) {
                return nomeArquivoXlsx.substring(i + 1);
            } else {
                return nomeArquivoXlsx;
            }
        },
        async atualizaStatus(row) {
            try {
                await LaudosService.atualizarStatusLaudo({
                    id: row.id
                });
            } catch (e) {}
        },
        downloadLaudo(laudo) {
            LaudosService.downloadLaudo(laudo.id)
                .then(() => {
                    this.$notify.success({
                        message: this.$t(
                            'mensagens.laudos.downloadRealizadoComSucesso'
                        )
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.laudos.erro.erroAoRealizarDownload'
                        )
                    });
                });
        },
        atualizarTabela() {
            this.$emit('atualizar');
        }
    }
};
</script>

<style lang="scss" scoped>
.el-table {
    .cell {
        word-break: break-word !important;
    }

    .action-button {
        cursor: pointer;
    }
}

.status {
    border-radius: 50px;
    text-align: center;
    color: var(--black);
}

.conforme {
    background-color: #d5f8d7;
    border: 1px solid #b0dcb3;
}

.nao-conforme {
    background-color: #f7d6da;
    border: 1px solid #e58585;
}

.buttonCard {
    background: var(--white);
    height: 60px;
    top: -15px;
    position: relative;
    padding: 10px;
}
</style>
